import React, { Fragment, ReactNode } from "react";

const Render = ({ when, children }: { when: any; children?: ReactNode }) => {
  return when ? <Fragment>{children}</Fragment> : null;
};

export default Render;
